{{#if error}}
<div class="alert alert-danger">{{error}}</div>
{{/if}}
<div class="form-group m-t-15" id="{{filterRegion}}"></div>
